import * as AbtConfigurationModule from './abt-configuration/abt-configuration.module';
import * as ChargeAccountModule from './charge-account/charge-account.module';
import * as DecodedItsoUploadModule from './decoded-itso-message-upload/decoded-itso-message-upload.module';
import * as RailSettlementModule from './rail-settlement/rail-settlement.module';
import * as SettlementPeriodModule from './settlement-period/settlement-period.module';
import * as TapsModule from './tap-events/tap-events.module';
import * as TapsReportModule from './taps-report/taps-report.module';
import * as UnratedJourneysModule from './unrated-journeys/unrated-journeys.module';
import * as BvcRulesModule from './usage-rating-rules/usage-rating-rules.module';


export const initialise = () => {

  TapsModule.initialise();
  ChargeAccountModule.initialise();
  SettlementPeriodModule.initialise();
  AbtConfigurationModule.initialise();
  UnratedJourneysModule.initialise();
  BvcRulesModule.initialise();
  DecodedItsoUploadModule.initialise();
  TapsReportModule.initialise();
  RailSettlementModule.initialise();

  angular.module('actora.abt', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    'ui.router',
    'app.settlement-period',
    'app.charge-account',
    'app.tap-events',
    'app.abt-configuration',
    'app.unrated-journeys',
    'app.usage-rating-rules',
    'app.decoded-itso-message-upload',
    'app.taps-report',
    'app.rail-settlement'
  ]);
};
